export default __webpack_public_path__ + "static/media/metamask.a437f283.svg";